module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "order-dialog",
    attrs: {
      "title": _vm.$t('actions.order.wechat.title'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.paid) ? _c('div', {
    staticClass: "content paid"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.paid')))])]) : (_vm.payType === 'wxpay') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.wechat.hint')))]), _vm._v(" "), _c('div', {
    staticClass: "img qrcode",
    style: ({
      'backgroundImage': 'url(//qrcode.ppj.io/' + _vm.qrcode + ')'
    })
  })]) : (_vm.payType === 'alipay') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("请在打开的支付宝页面中完成付款")])]) : (_vm.errorMsg) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.loading')))]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('p', [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.$contactCS
    }
  }, [_vm._v("遇到问题？")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('spinner', {
    staticClass: "spinner",
    attrs: {
      "size": 180,
      "percentage": 80
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2d97d86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/order/order.dialog.vue
// module id = 953
// module chunks = 3